import moment from "moment";

export const NATIVE_DATE_FORMAT = "YYYY-MM-DD";
export const NATIVE_DATETIME_FORMAT = "YYYY-MM-DD HH:mm:ss";
export const USER_DATE_FORMAT = "DD/MM/YYYY";
export const USER_DATETIME_FORMAT = "DD/MM/YYYY HH:mm:ss";

export const formatNative = (date) => {
  return moment(date).format(NATIVE_DATE_FORMAT);
};

export const formatNativeDatetime = (date) => {
  return moment(date).format(NATIVE_DATETIME_FORMAT);
};

export const formatUserDate = (date) => {
  return moment(date).format(USER_DATE_FORMAT);
};

export const formatUserDatetime = (date) => {
  return moment(date).format(USER_DATETIME_FORMAT);
};

export function roundMinutes(datetime, multiple = 5) {
  if (!datetime) {
    return datetime;
  }

  const minutes = datetime.getMinutes();
  const remainder = minutes % multiple;
  if (remainder !== 0) {
    datetime.setMinutes(minutes + (multiple - remainder));
  }

  return datetime;
}

const datetime = {
  NATIVE_DATE_FORMAT,
  NATIVE_DATETIME_FORMAT,
  USER_DATETIME_FORMAT,
  formatNative,
  roundMinutes,
};

export default datetime;
